import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomBoard from "../../components/CustomBoard";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as registrationSelector from "../../../common/selectors/registration";
import * as registrationAction from "../../../common/actions/registration";
import CustomToast from "../../components/CustomToast";
import LoadingOverlay from "../../components/LoadingOverlay";
import AuthManager from "../../../utils/AuthManager";
import RegistrationForm from "./components/RegistrationForm";

class Registrationv1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nric: "",
      height: 0,
      customToastStatus: false,
      toastMessage: "",
      registrationAction: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {

    
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onChangeNRIC = (event) => {
  
    this.setState({ nric: event.target.value });
  };

  onClickNext = () => {
    
  };

  onClickContactUs = () => {
    
  };

  onClickBack = () => {
    window.history.back();
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  render() {
    const { classes,registrationReqLoading } = this.props;
    const { height, nric } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard
          children={
            <RegistrationForm
              nric={nric}
              onChangeNRIC={this.onChangeNRIC}
              onClickNext={this.onClickNext}
              onClickContactUs={this.onClickContactUs}
              onClickBack={this.onClickBack}
            />
          }
          height={height}
        />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
          {registrationReqLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
});

function mapStateToProps(state) {
  return {
    // registrationReqData: selector.registrationReqData(state),
    // registrationReqLoading: selector.registrationReqLoading(state),
    // registrationReqStatus: selector.registrationReqStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // registrationRequest: (nric) =>
    //   dispatch(registrationAction.registrationRequest(nric)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(Registrationv1)));
